import React from "react";
import { Link } from "react-router-dom";
import { assetUrl } from "../../../utils/assetUrl";
import "./s.css";

const ItemList = ({ product }) => {
  return (
    <>
      <div className="list">
        <div className="data" id={product.id}>
          <h1 key={product.Titulo}>{product.Titulo}</h1>
          <p>VINO TINTO</p>
          <p className="descripcion">{product.Descripcion}</p>
        </div>
        <div className="vinoImg">
          <img src={assetUrl(product.imagen)} alt={product.Titulo} />
        </div>
      </div>
      <div className="boton">
        <Link to={`/vinos/${product.Titulo}`}>
          <button>Conocer más</button>
        </Link>
      </div>
    </>
  );
};

export default ItemList;